import React, { useRef } from "react";
import Popup from "reactjs-popup";
import { getValue } from "@utils/lodash";

function ReimbursementTooltipOnHover(props) {
  const POSITION_TYPES = [
    "bottom right",
    "bottom center",
    "top center",
    "left top",
    "left bottom",
    "right top",
    "top left",
    "top center",
    "right center",
    "right bottom",
    "bottom left",
    "left center",
    "center center",
  ];

  const popupRef = useRef();
  const handleClose = (e) => {
    e.stopPropagation();
    if (popupRef.current) {
      popupRef.current.close();
    }
  };
  const handleOpen = () => {
    if (popupRef.current) {
      popupRef.current.open();
    }
  };

  const CustomButtons = React.forwardRef(({ open, ...props }, ref) => (
    <div
      className="d-flex justify-content-between align-items-center cursor-pointer"
      {...props}
      ref={ref}
    >
      {props.header}
    </div>
  ));
  const { formInfo } = props;
  return (
    <Popup
      trigger={(open) => <CustomButtons open={open} header={props.header} />}
      position={POSITION_TYPES}
      closeOnDocumentClick
      on={"click"}
      contentStyle={{
        width: getValue(props, `width`, "")
          ? getValue(props, `width`, "")
          : "400px",
        minHeight: getValue(props, `height`, "")
          ? getValue(props, `height`, "")
          : "70px",
        zIndex: 9999,
        background: getValue(props, `background`, "")
          ? getValue(props, `background`, "")
          : "#202124",
        boxShadow:
          "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
      }}
      nested
      ref={popupRef}
      onOpen={handleOpen}
      onClick={handleClose}
      arrowStyle={{
        color: getValue(props, `background`, "")
          ? getValue(props, `background`, "")
          : "#202124",
      }}
    >
      <div onClick={handleClose} className="position-relative">
        <div className="d-flex justify-content-around p-3">
          <div>
            <p className="small_text__14">Reimbursable Amount:</p>
            <h6 className="header_text__16">
              {getValue(formInfo, `reimbursement.currency_symbol`, "")}{' '}
              {getValue(formInfo, `reimbursement.reimbursable_total`, "")}
            </h6>
          </div>
          <div>
            <h6 className="header_text__16">
             =
            </h6>
          </div>
          <div>
            <p className="small_text__14">Reimbursed Amount:</p>
            <h6 className="header_text__16">
              {getValue(formInfo, `reimbursement.currency_symbol`, "")}{' '}
              {getValue(formInfo, `reimbursement.reimbursed_total`, "")}
            </h6>
          </div>
        </div>
      </div>
    </Popup>
  );
}

export default ReimbursementTooltipOnHover;
